import { gql } from "@apollo/client";

const GET_PLANT_CATEGORIES = gql`
  query plantCategories {
    plantCategories {
      id
      name
      description
    }
  }
`;

const GET_SPACES = gql`
  query spaces {
    spaces {
      id
      name
      description
    }
  }
`;

const GET_MAINTENANCE_LEVELS = gql`
  query MaintenanceLevels {
    maintenanceLevels {
      id
      name
    }
  }
`;

const GET_LIGHT_LEVELS = gql`
  query LightLevels {
    lightLevels {
      id
      name
    }
  }
`;

const GET_WATER_FREQUENCIES = gql`
  query waterFrequencies {
    waterFrequencies {
      id
      name
      description
    }
  }
`;

const GET_ALL_PLANT_CARE_PROPERTIES = gql`
  query getAllPlantProperties {
    lightLevels {
      id
      name
    }
    maintenanceLevels {
      id
      name
    }
    waterFrequencies {
      id
      name
    }
  }
`;

const GET_MATCHED_PLANTS = gql`
  query plantsMatchedWithModsForUserPreferences(
    $space_id: Int!
    $plant_category_id: Int!
    $light_availability: Int!
    $water_frequency_id: Int!
    $distance_from_source: Int!
  ) {
    plantsMatchedWithModsForUserPreferences(
      space_id: $space_id
      plant_category_id: $plant_category_id
      light_availability: $light_availability
      water_frequency_id: $water_frequency_id
      distance_from_source: $distance_from_source
    ) {
      id
      name
      scientific_name
      short_description
      description
      image_url
      light_levels
      water_frequency_id
      maintenance_level_id
      unlocked
    }
  }
`;

const GET_MATCHED_PLANTS_DETAILS = gql`
  query plantDetailsMatchedWithModsForUserPreferences(
    $space_id: Int!
    $plant_category_id: Int!
    $light_availability: Int!
    $water_frequency_id: Int!
    $distance_from_source: Int!
  ) {
    plantDetailsMatchedWithModsForUserPreferences(
      space_id: $space_id
      plant_category_id: $plant_category_id
      light_availability: $light_availability
      water_frequency_id: $water_frequency_id
      distance_from_source: $distance_from_source
    ) {
      id
      name
      scientific_name
      mini_description
      short_description
      description
      image_url
      light_levels
      light_levels_desc
      water_frequency_id
      water_frequency
      nutrition_frequency_id
      nutrition_frequency
      maintenance_level_id
      maintenance_level
      plant_category_id
      plant_category
      nutrition_preference
      humidity_preference
      space
      products {
        product_type_id
        name
      }
      unlocked
    }
  }
`;

const GET_PLANT_DETAILS = gql`
  query PlantDetailsById($id: Int) {
    plantDetailsById(id: $id) {
      id
      name
      scientific_name
      mini_description
      light_levels_desc
      water_frequency
      maintenance_level
      unlocked
      image_url
      uses
      facts
      setup
      care
    }
  }
`;

const GET_PLANTS = gql`
  query Plants {
    plants {
      id
      scientific_name
      name
      image_url
    }
  }
`;

const GET_PLANT_IDS = gql`
  query PlantIds {
    plantIds {
      id
    }
  }
`;

const GET_PLANTS_SUBSCRIPTIONS = gql`
  query plantSubscriptionList($limit: Int!, $offset: Int!) {
    plantSubscriptionList(limit: $limit, offset: $offset) {
      plant_id
      scientific_name
      name
      image_url
      count
    }
  }
`;

const GET_PLANTS_SEARCH_FILTER = gql`
  query SearchPlants(
    $userPhone: String
    $searchString: String
    $userId: Int
    $pageLimit: Int
    $page: Int
  ) {
    searchPlants(
      user_phone: $userPhone
      search_string: $searchString
      user_id: $userId
      page_limit: $pageLimit
      page: $page
    ) {
      page
      total_pages
      total_results
      query_id
      plants {
        id
        scientific_name
        name
        family
        care
        light
        water
        soil_preference
        planter_preference
        given_name
        image_url
        description
        objectID
      }
    }
  }
`;

export {
  GET_PLANT_CATEGORIES,
  GET_SPACES,
  GET_WATER_FREQUENCIES,
  GET_MATCHED_PLANTS,
  GET_MATCHED_PLANTS_DETAILS,
  GET_PLANT_DETAILS,
  GET_PLANTS,
  GET_PLANT_IDS,
  GET_PLANTS_SEARCH_FILTER,
  GET_PLANTS_SUBSCRIPTIONS,
  GET_ALL_PLANT_CARE_PROPERTIES,
  GET_MAINTENANCE_LEVELS,
  GET_LIGHT_LEVELS,
};
